import {
  CalendarIcon,
  CopyIcon,
  EyeIcon,
  ListOrderedIcon,
  PencilIcon,
  PlusIcon,
  SyncIcon,
  TrashIcon,
} from "@primer/octicons-react";

import { Box, Checkbox, Label } from "@primer/react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Transition } from "semantic-ui-react";
import { hinhThucMienGiamApi } from "../../api/hinhThucMienGiamApi";
import { hinhThucMienGiamGroupApi } from "../../api/hinhThucMienGiamGroupApi";
import { AnimationConfirm } from "../../components/confirm";
import { AnimationPopup } from "../../components/modal";
import SelectBoxMultipleNhomMienGiam from "../../components/selectbox-multiple-nhommiengiam";
import Button from "../../components/ui/button";
import MyIconButton from "../../components/ui/button/IconButton";
import DataTable from "../../components/ui/data-table";
import TextWithEllipse from "../../components/ui/text-with-ellipse";
import { PageBaseStatus } from "../../models/pageBaseStatus";
import { sf_hinhthucmiengiam } from "../../models/response/category/sf_hinhthucmiengiam";
import { sf_hinhthucmiengiam_hinhthuctinh } from "../../models/response/category/sf_hinhthucmiengiam_hinhthuctinh";
import { sf_hinhthucmiengiam_group } from "../../models/response/hinh-thuc-mien-giam/sf_hinhthucmiengiam_group";
import {
  changeHinhThucMienGiamNamHocAction,
  changeHinhThucMienGiamSelectionIds,
  closeHinhThucMienGiamCopyModalAction,
  closeHinhThucMienGiamDeleteConfirm,
  closeHinhThucMienGiamDetailModal,
  closeHinhThucMienGiamItemsModalAction,
  deleteHinhThucMienGiamStart,
  loadHinhThucMienGiamStart,
  saveHinhThucMienGiamStart,
  showHinhThucMienGiamCopyModalAction,
  showHinhThucMienGiamDeleteConfirm,
  showHinhThucMienGiamDetailModal,
  showHinhThucMienGiamItemsModalAction,
} from "../../state/actions/hinhThucMienGiamActions";
import { RootState } from "../../state/reducers";
import { MienGiamCopyModal } from "./copy_modal";
import { MienGiamItemsModal } from "./detail_items";
import HinhThucMienGiamEditModal from "./HinhThucMienGiamEditModal";

const HinhThucMienGiamPage = () => {
  const state = useSelector((state: RootState) => state.hinhThucMienGiam);
  const { nam_hoc: param_nam_hoc, dm_coso_id } = useSelector(
    (x: RootState) => x.common
  );
  const [sf_hinhthucmiengiam_group, set_sf_hinhthucmiengiam_group] = useState<
    sf_hinhthucmiengiam_group[]
  >([]);
  const [danhSachMienGiamSelectId, setDanhSachMienGiamSelectId] = useState<
    number[]
  >([]);
  const [sf_hinhthucmiengiam, set_sf_hinhthucmiengiam] =
    useState<sf_hinhthucmiengiam>();

  const [nhomMienGiamFilter, setNhomMienGiamFilter] = useState<number[]>([]);
  const [hinhthucmiengiam_hinhthuctinhs, set_hinhthucmiengiam_hinhthuctinhs] =
    useState<sf_hinhthucmiengiam_hinhthuctinh[]>([]);

  const dispatch = useDispatch();
  const {
    status,
    sf_hinhthucmiengiams,
    is_show_detail_modal,
    is_show_delete_confirm,
    is_show_items_modal,
    sf_hinhthucmiengiam_editing,
    nam_hoc,
    is_show_copy_modal,
  } = state;
  useEffect(() => {
    dispatch(changeHinhThucMienGiamNamHocAction(param_nam_hoc));
  }, [param_nam_hoc]);
  useEffect(() => {
    handleReloadHinhThucMienGiamGroup();
    dispatch(loadHinhThucMienGiamStart(nam_hoc));
    dispatch(closeHinhThucMienGiamItemsModalAction());
    handleReloadHinhThucTinh();
  }, [nam_hoc]);

  useEffect(() => {
    handleReloadHinhThucMienGiamGroup();
    dispatch(loadHinhThucMienGiamStart(nam_hoc));
    handleReloadHinhThucTinh();
  }, []);

  const handleCloseDeleteConfirm = useCallback(() => {
    dispatch(closeHinhThucMienGiamDeleteConfirm());
  }, []);
  const handleShowDeleteConfirm = useCallback(() => {
    dispatch(showHinhThucMienGiamDeleteConfirm());
  }, []);

  const handleBtnEditClicked = (data: sf_hinhthucmiengiam) => {
    dispatch(showHinhThucMienGiamDetailModal(data));
  };

  const handleConfirmDelete = useCallback(() => {
    dispatch(deleteHinhThucMienGiamStart(danhSachMienGiamSelectId));
    setTimeout(() => {
      dispatch(loadHinhThucMienGiamStart(nam_hoc));
    }, 500);
  }, [dispatch, danhSachMienGiamSelectId]);

  const handleCloseDetailModal = useCallback(() => {
    dispatch(closeHinhThucMienGiamDetailModal());
    dispatch(loadHinhThucMienGiamStart(nam_hoc));
  }, [dispatch]);
  const handleSubmitDetailModal = useCallback((data: sf_hinhthucmiengiam) => {
    dispatch(saveHinhThucMienGiamStart(data));
    dispatch(changeHinhThucMienGiamSelectionIds([]));
    setTimeout(() => {
      dispatch(loadHinhThucMienGiamStart(nam_hoc));
    }, 500);
  }, []);

  const handleCloseItemsModal = useCallback(() => {
    dispatch(closeHinhThucMienGiamItemsModalAction());
  }, []);

  const handleReloadHinhThucMienGiamGroup = async () => {
    const res = await hinhThucMienGiamGroupApi.selectAll();
    if (res.is_success) {
      set_sf_hinhthucmiengiam_group(
        res.data.filter((x: any) => x.dm_coso_id == dm_coso_id)
      );
    }
  };
  const handleReloadHinhThucTinh = async () => {
    const res = await hinhThucMienGiamApi.select_hinhthuctinhs();
    if (res.is_success) {
      set_hinhthucmiengiam_hinhthuctinhs(res.data);
    }
  };
  const dataSource = useMemo(() => {
    let sortAppends = [
      ...sf_hinhthucmiengiams.filter(
        (x) => x.dm_coso_id === dm_coso_id
      ),
    ];
    if (nhomMienGiamFilter.length > 0) {
      sortAppends = sortAppends.filter((x) =>
        nhomMienGiamFilter.includes(x.sf_hinhthucmiengiam_group_id)
      );
    }
    return sortAppends;
  }, [sf_hinhthucmiengiams, nhomMienGiamFilter, dm_coso_id, nam_hoc]);

  const columns = useMemo(() => {
    const currentDate = new Date();
    let result: any = [
      {
        id: "actions",
        caption: "#",
        width: 80,
        align: "center",
        fixed: true,
        fixedPosition: "left",
        cellRender: (data: any) => (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <MyIconButton
              id={`btnItem${data.id}`}
              icon={ListOrderedIcon}
              title="Điều chỉnh khoản miễn giảm"
              variant="invisible"
              size="small"
              onClick={() => {
                dispatch(showHinhThucMienGiamItemsModalAction(data));
              }}
              sx={{
                color: "#0969da",
                "&:hover": {
                  color: "#0550ae",
                  backgroundColor: "#ddf4ff",
                },
                minWidth: "24px",
                minHeight: "24px",
                padding: "2px",
              }}
              aria-label="Xem chi tiết"
            />
            <MyIconButton
              id={`btnEdit${data.id}`}
              icon={PencilIcon}
              variant="invisible"
              size="small"
              onClick={() => {
                handleBtnEditClicked(data);
              }}
              sx={{
                color: "#1f883d",
                "&:hover": {
                  color: "#116329",
                  backgroundColor: "#dcfce7",
                },
                minWidth: "24px",
                minHeight: "24px",
                padding: "2px",
              }}
              aria-label="Chỉnh sửa"
            />
            <MyIconButton
              id={`btnDelete${data.id}`}
              icon={TrashIcon}
              variant="invisible"
              size="small"
              onClick={() => {
                setDanhSachMienGiamSelectId([data.id]);
                handleShowDeleteConfirm();
              }}
              sx={{
                color: "#d1242f",
                "&:hover": {
                  color: "#a40e26",
                  backgroundColor: "#ffebe9",
                },
                minWidth: "24px",
                minHeight: "24px",
                padding: "2px",
              }}
              aria-label="Xóa"
            />
          </Box>
        ),
      },
      {
        caption: "Nhóm miễn giảm",
        id: "sf_hinhthucmiengiam_group_id",
        dataField: "sf_hinhthucmiengiam_group_id",
        width: 150,
        fixed: true,
        fixedPosition: "left",
        cellRender: (data: any) => {
          const group = sf_hinhthucmiengiam_group
            .filter((c) => c.dm_coso_id === dm_coso_id)
            .find((g) => g.id === data.sf_hinhthucmiengiam_group_id);
          const text = group
            ? `(${group.thu_tu}) ${group.ten_nhom_mien_giam}`
            : "";
          return <TextWithEllipse text={text} lineNumber={1} />;
        },
      },
      {
        caption: "Mã miễn giảm",
        id: "ma_hinh_thuc",
        dataField: "ma_hinh_thuc",
        width: 120,
        alignment: "left",
        fixed: true,
        fixedPosition: "left",
        cellRender: (data: any) => {
          return (
            <Box>
              <span style={{ fontWeight: 700, marginLeft: 2 }}>
                <Label variant="accent">
                  {data.ma_nhom_mien_giam}-{data.ma_hinh_thuc}
                </Label>
              </span>
            </Box>
          );
        },
      },
      {
        caption: "Tên miễn giảm",
        id: "hinh_thuc_mien_giam",
        dataField: "hinh_thuc_mien_giam",
        width: 150,
        alignment: "left",
        cellRender: (data: any) => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <TextWithEllipse
              text={data.hinh_thuc_mien_giam || ""}
              lineNumber={1}
            />
          </div>
        ),
      },
      {
        caption: "Hình thức tính",
        id: "sf_hinhthucmiengiam_hinhthuctinh_id",
        dataField: "sf_hinhthucmiengiam_hinhthuctinh_id",
        width: 150,
        alignment: "left",
        cellRender: (data: any) => {
          const group = hinhthucmiengiam_hinhthuctinhs.find(
            (g) => g.id === data.sf_hinhthucmiengiam_hinhthuctinh_id
          );
          return (
            <TextWithEllipse
              text={group?.hinh_thuc_tinh || ""}
              lineNumber={1}
            />
          );
        },
      },
      {
        caption: "Thời gian áp dụng",
        id: "tu_ngay",
        dataField: "tu_ngay",
        width: 220,
        alignment: "left",
        cellRender: (data: any) => {
          const formatDate = (date: string | Date | null) => {
            if (!date) return "";
            return new Intl.DateTimeFormat("vi-VN", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }).format(new Date(date));
          };
          return (
            <Box>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  fontWeight: 500,
                }}
              >
                <span style={{ color: "green" }}>
                  <CalendarIcon size={16} />
                </span>
                <span>{formatDate(data.tu_ngay)}</span>
                <span>-</span>
                <span style={{ color: "red" }}>
                  <CalendarIcon size={16} />
                </span>
                <span>{formatDate(data.den_ngay)}</span>
              </div>
            </Box>
          );
        },
      },
      {
        caption: "Trạng thái",
        id: "den_ngay",
        dataField: "den_ngay",
        width: 100,
        cellRender: (data: any) => {
          const endDate = new Date(data.den_ngay);
          return (
            <Box>
              {endDate > currentDate ? (
                <Label variant="success">Khả dụng</Label>
              ) : (
                <Label variant="danger">Hết hạn</Label>
              )}
            </Box>
          );
        },
      },

      {
        caption: "Áp dụng toàn trường",
        id: "is_apdung_toantruong",
        dataField: "is_apdung_toantruong",
        width: 160,
        cellRender: (data: any) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Checkbox
              checked={data.is_apdung_toantruong === true}
              aria-label="Áp dụng toàn trường"
            />
          </div>
        ),
      },
    ];
    return result;
  }, [
    sf_hinhthucmiengiams,
    hinhthucmiengiam_hinhthuctinhs,
    sf_hinhthucmiengiam_group,
  ]);
  return (
    <React.Fragment>
      <Box sx={{ p: 2 }}>
        <Transition
          animation="scale"
          visible={true}
          duration={100}
          transitionOnMount={true}
        >
          <Box>
            <DataTable
              data={dataSource}
              height="calc(100vh - 200px)"
              filterRow={{
                enable: true,
              }}
              selection={{
                mode: "single",
                keyExpr: "id",
                selectedRowKeys: danhSachMienGiamSelectId,
                onSelectionChanged(keys) {
                  setDanhSachMienGiamSelectId(keys);
                },
              }}
              onClick={(e: any) => {
                setDanhSachMienGiamSelectId(e.rowData.id);
                set_sf_hinhthucmiengiam(e.rowData);
              }}
              exportEnable
              actionComponent={
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <SelectBoxMultipleNhomMienGiam
                    value={nhomMienGiamFilter}
                    onValueChanged={(value) => {
                      setNhomMienGiamFilter(value === null ? [] : value);
                    }}
                    size="small"
                  />
                  <Button
                    size="small"
                    variant="default"
                    leadingVisual={SyncIcon}
                    onClick={() => dispatch(loadHinhThucMienGiamStart(nam_hoc))}
                  >
                    Làm mới
                  </Button>
                  <Button
                    size="small"
                    variant="primary"
                    leadingVisual={PlusIcon}
                    onClick={() => {
                      dispatch(showHinhThucMienGiamDetailModal(undefined));
                      set_sf_hinhthucmiengiam(undefined);
                      dispatch(showHinhThucMienGiamDetailModal());
                    }}
                  >
                    Thêm mới
                  </Button>
                  <Button
                    size="small"
                    leadingVisual={CopyIcon}
                    variant="primary"
                    onClick={() =>
                      dispatch(showHinhThucMienGiamCopyModalAction())
                    }
                  >
                    Sao chép từ năm học cũ
                  </Button>
                </Box>
              }
              columns={columns}
              paging={{
                enable: true,
                pageSizeItems: [50, 200, 500, 1000],
              }}
            />
          </Box>
        </Transition>

        {/* Modal hiển thị chi tiết miễn giảm */}
        {is_show_items_modal && sf_hinhthucmiengiam_editing && (
          <AnimationPopup
            animationOf={`#btnItem${sf_hinhthucmiengiam_editing.id}`}
            title={`Chi tiết miễn giảm: ${sf_hinhthucmiengiam_editing.hinh_thuc_mien_giam}`}
            width="80%"
            onClose={handleCloseItemsModal}
          >
            <MienGiamItemsModal
              sf_hinhthucmiengiam={sf_hinhthucmiengiam_editing}
              animationOf={`#btnItem${sf_hinhthucmiengiam_editing.id}`}
              onClose={handleCloseItemsModal}
              onEditRequest={() => {
                handleBtnEditClicked(sf_hinhthucmiengiam_editing);
              }}
            />
          </AnimationPopup>
        )}

        {is_show_detail_modal && (
          <HinhThucMienGiamEditModal
            onClose={handleCloseDetailModal}
            onSubmit={handleSubmitDetailModal}
            sf_hinhthucmiengiam={sf_hinhthucmiengiam}
            is_saving={status === PageBaseStatus.is_saving}
            nam_hoc={nam_hoc}
            animationOf={sf_hinhthucmiengiam ? `#btnEdit` : "#btnInsert"}
            title={sf_hinhthucmiengiam ? `Cập nhật` : "Thêm mới"}
            sf_hinhthucmiengiams={sf_hinhthucmiengiams}
          />
        )}
        {is_show_delete_confirm && (
          <AnimationConfirm
            onClose={handleCloseDeleteConfirm}
            onConfirmed={handleConfirmDelete}
            text={`Bạn có chắc chắn muốn xóa hình thức miễn giảm đã chọn ?`}
            is_saving={status === PageBaseStatus.is_deleting}
            text_close_button="Không xóa"
            text_confirm_button="Xóa miễn giảm"
            type="danger"
            animationOf={`#ListItem${danhSachMienGiamSelectId[0]}`}
          />
        )}

        {is_show_copy_modal && nam_hoc && (
          <MienGiamCopyModal
            nam_hoc_to={nam_hoc}
            animationOf="#btnInsert"
            onClose={() => {
              dispatch(closeHinhThucMienGiamCopyModalAction());
            }}
            onSuccess={() => {
              dispatch(closeHinhThucMienGiamCopyModalAction());
              dispatch(loadHinhThucMienGiamStart(nam_hoc));
            }}
          />
        )}
      </Box>
    </React.Fragment>
  );
};
export default HinhThucMienGiamPage;
